import { useDispatch, useSelector, useStore } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Типизированные обёртки RTK — использовать вместо «голых» хуков react-redux.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<typeof import('./store').store>();
